
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/research-studies/vocabulary-engagement-oman",
      function () {
        return require("private-next-pages/research-studies/vocabulary-engagement-oman.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/research-studies/vocabulary-engagement-oman"])
      });
    }
  